//Modules
import React from "react"
import { Link } from "gatsby"
//Styles
import styled from "styled-components"
import { flex, font, spacing } from "../../../Utilities"
//Constants
import { menu } from "../../../constants/menu"

const MobileNavMenu = () => {
  return (
    <StyledMobileNavContent>
      {menu.map((menuItem, i) => {
        return (
          <Link
            key={i}
            to={menuItem.path}
            className="mobile-item"
            activeClassName="active-link"
          >
            {menuItem.name}
          </Link>
        )
      })}
    </StyledMobileNavContent>
  )
}

const StyledMobileNavContent = styled.div`
  ${flex("column")};
  padding: ${spacing.M};
  margin-top: ${spacing.L};

  @media (min-width: 768px) {
    padding: ${spacing.XL};
  }

  .mobile-item {
    ${font("SM")};
    margin-bottom: ${spacing.S};

    @media (min-width: 768px) {
      ${font("L")};
    }
  }
`

export default MobileNavMenu
